// Announced on `window` after every successful write to a clinical record
// (src/axios.js), so whatever shows what is outstanding, the home notification
// feed first (TGCLOUD-1896), reads again instead of waiting for a reload.
//
// Its own module rather than an export of src/axios.js, which many tests
// replace wholesale with a mock that would not carry it.
export const CLINICAL_RECORDS_CHANGED = 'tg:clinical-records-changed';
